import clsx from 'clsx';
import React, { useState } from 'react';
import { Box, Divider, Typography, Container, Button, Link } from '@mui/material';
import EmbedVideo from 'components/EmbedVideo';
import Brands from 'components/Brands';
import Testimonials from 'components/Testimonials';
import { useStyles } from './styles';
import LazyLoad from 'react-lazyload';

const teamAreaButtons = [
  { label: 'Management', area: 'management' },
  { label: 'Marketing', area: 'marketing' },
  { label: 'Design', area: 'design' },
  { label: 'Tech', area: 'tech' },
];

const teamMembers = [
  {
    avatarUrl: '/images/avatars/aayushi.png',
    name: 'Aayushi Zaveri',
    role: 'Content Writer',
    linkedinUrl: 'https://www.linkedin.com/in/aayushizaveri/',
    area: 'marketing',
  },
  {
    avatarUrl: '/images/avatars/alka.jpg',
    name: 'Alka Dawar',
    role: 'Strategy Manager',
    linkedinUrl: 'https://www.linkedin.com/in/alkadawar/',
    area: 'marketing',
  },
  {
    avatarUrl: '/images/avatars/amanda.png',
    name: 'Amanda Nascimento',
    role: 'Head of Marketing',
    linkedinUrl: 'https://www.linkedin.com/in/amanda-nascimento-mkt-pp/',
    area: 'marketing',
  },
  {
    avatarUrl: '/images/avatars/artur.png',
    name: 'Artur Zignani',
    role: 'UX Writer',
    linkedinUrl: 'https://www.linkedin.com/in/arturzignani/',
    area: 'marketing',
  },
  {
    avatarUrl: '/images/avatars/bryan.png',
    name: 'Bryan Didur',
    role: 'Developer',
    linkedinUrl: 'https://www.linkedin.com/in/bryan-didur-417472182/',
    area: 'tech',
  },
  {
    avatarUrl: '/images/avatars/camilla.png',
    name: 'Camilla Tsuji',
    role: 'Social Media & Community Manager',
    linkedinUrl: 'https://www.linkedin.com/in/camillatsuji/',
    area: 'marketing',
  },
  {
    avatarUrl: '/images/avatars/fabricio.png',
    name: 'Fabrício Pamplona',
    role: 'Founder & CEO',
    linkedinUrl: 'https://www.linkedin.com/in/fabriciopamplona/',
    area: 'management',
  },
  {
    avatarUrl: '/images/avatars/fernanda.png',
    name: 'Fernanda Rediske',
    role: 'Illustrator',
    linkedinUrl: 'https://www.linkedin.com/in/fernanda-losekann-rediske/',
    area: 'design',
  },
  {
    avatarUrl: '/images/avatars/gustavo.png',
    name: 'Gustavo Tavares',
    role: 'DevOps',
    linkedinUrl: 'https://www.linkedin.com/in/gustavares/',
    area: 'tech',
  },
  {
    avatarUrl: '/images/avatars/leonardo.png',
    name: 'Leonardo Minozzo',
    role: 'Founder',
    linkedinUrl: 'https://www.linkedin.com/in/leonardominozzo/',
    area: 'management',
  },
  {
    avatarUrl: '/images/avatars/marcelo.png',
    name: 'Marcelo Camacho',
    role: 'Illustrator',
    linkedinUrl: 'https://www.linkedin.com/in/marcelo-camacho-a8b1a865/',
    area: 'design',
  },
  {
    avatarUrl: '/images/avatars/maria.png',
    name: 'Maria Queiroz',
    role: 'BI Developer',
    linkedinUrl: 'https://www.linkedin.com/in/maria-queiroz/',
    area: 'tech',
  },
  {
    avatarUrl: '/images/avatars/matheus.png',
    name: 'Matheus Czizeweski',
    role: 'Head of Development',
    linkedinUrl: 'https://www.linkedin.com/in/matheus-czizeweski-44a11931/',
    area: 'tech',
  },
  {
    avatarUrl: '/images/avatars/nelito.jpg',
    name: 'Nelito Junior',
    role: 'Developer',
    linkedinUrl: 'https://www.linkedin.com/in/nelito-jr-76b349240/',
    area: 'tech',
  },
  {
    avatarUrl: '/images/avatars/Prince-Jude.jpg',
    name: 'Prince Jude',
    role: 'Customer Success Manager',
    linkedinUrl: 'https://www.linkedin.com/in/prince-jude-a8588943/',
    area: 'marketing',
  },
  {
    avatarUrl: '/images/avatars/priyanka.webp',
    name: 'Priyanka Iyer',
    role: 'Customer Success Analyst',
    area: 'marketing',
  },
  {
    avatarUrl: '/images/avatars/purv.png',
    name: 'Purv Desai',
    role: 'Content Writer',
    linkedinUrl: 'https://www.linkedin.com/in/dr-purvi-desai-395b0bb9/',
    area: 'marketing',
  },
  {
    avatarUrl: '/images/avatars/sowjanya.jpg',
    name: 'Sowjanya Pedada',
    role: 'Content Writer',
    linkedinUrl: 'https://www.linkedin.com/in/sowjanya-pedada/',
    area: 'marketing',
  },
  {
    avatarUrl: '/images/avatars/tania.webp',
    name: 'Tania Basu',
    role: 'People & Culture Manager',
    linkedinUrl: 'https://www.linkedin.com/in/tania-basu-64551b3a/',
    area: 'management',
  },
  {
    avatarUrl: '/images/avatars/vagner.png',
    name: 'Vagner Maltauro',
    role: 'Developer',
    linkedinUrl: 'https://www.linkedin.com/in/vagnermaltauro/',
    area: 'tech',
  },
  {
    avatarUrl: '/images/avatars/vincent.webp',
    name: 'Vincent Schneider',
    role: 'Head of Design',
    linkedinUrl: 'https://www.linkedin.com/in/vincent-d-schneider/',
    area: 'design',
  },
];

export default function MainContent() {
  const classes = useStyles();
  const [teamArea, setTeamArea] = useState();

  return (
    <>
      <Box py={6} bgcolor="common.white" textAlign="center">
        <Container>
          <Typography className={classes.primaryColor} variant="h1" gutterBottom={true}>
            <b className={classes.b}>About Mind The Graph!</b>
          </Typography>

          <Typography>
            Revolutionizing scientific communication and empowering <br />
            scientists to make science beautiful for every audience.
          </Typography>

          <LazyLoad>
            <Box display="inline-block" mt={4}>
              <section aria-label="Video">
                <EmbedVideo url="https://www.youtube.com/embed/ZdZH2V9Ni1Q" width="500" />
              </section>
            </Box>
          </LazyLoad>
        </Container>
      </Box>

      <Box py={6} bgcolor="grey.200" textAlign="center">
        <Container>
          <Typography className={classes.primaryColor} variant="h2" gutterBottom={true}>
            <b>Our Story</b>
          </Typography>

          <Box mb={4}>
            <Typography>
              Mind the Graph was created with scientist's needs in mind back in 2016 by the
              brilliant minds <br />
              of Fabricio Pamplona, an entrepreneur and Ph.D. scientist specialist in scientific
              communication, <br />
              and Leonardo Minozzo, an experienced and accomplished designer.
            </Typography>
          </Box>

          <Box mb={4}>
            <Typography>
              Together they conceived a tool to help scientists, academics and healthcare
              professionals to <br />
              transform their complex scientific content into simple, didactic, and beautiful
              science figures, <br />
              offering a much better alternative to the excessive Google images searches and
              high-priced <br />
              freelance services. The company explored the tendency of using "graphical abstracts"
              in <br />
              scientific publications as a great business opportunity worldwide.
            </Typography>
          </Box>

          <Box mb={4}>
            <Typography>
              The scientific content is usually complex in itself, so Mind the Graph was created
              with a <br />
              minimalist design essence. The tool combines the essential design features available{' '}
              <br />
              in a familiar drag-and-drop interface with a powerful library of science
              illustrations, currently <br />
              the biggest in the world and available in a freemium model for the academic community.
            </Typography>
          </Box>

          <Typography>
            In 2022, Mind the Graph became part of Cactus Communications, a science communication
            <br />
            and technology company. Mind the Graph’s online platform and technology is now available{' '}
            <br />
            to researchers under the suite of solutions offered by Editage, CACTUS’s flagship brand.
          </Typography>

          <Divider className={classes.divider} />

          <Typography className={classes.primaryColor} variant="h2" gutterBottom={true}>
            <b>Our Mission</b>
          </Typography>

          <Box mb={4}>
            <Typography>
              Science communication is not a discipline taught in most science-related courses, and
              very often, <br />
              researchers lack design skills or access to professional software. Still, there's a
              120% growth in citations <br />
              for articles with infographics, meaning they are really powerful in generating buzz
              around research.
            </Typography>
          </Box>

          <Typography>
            So, how do you create interesting infographics from scratch, without professional
            resources or design <br />
            skills? That's the gap we want to fill in with Mind the Graph: "turn scientists into
            designers" and <br />
            unlock creativity with all visual resources needed for an effective science
            communication.
          </Typography>

          <Divider className={classes.divider} />

          <Typography className={classes.primaryColor} variant="h2" gutterBottom={true}>
            <b>Our Values</b>
          </Typography>

          <LazyLoad>
            <div className={classes.companyValues}>
              <div className={classes.companyValueBox}>
                <img src="/images/walls-breaker-icon.svg" alt="Walls breaker icon" />

                <Typography className={classes.primaryColor} gutterBottom={true}>
                  <b>Walls Breaker</b>
                </Typography>
                <Typography>
                  Make it all simpler. <br />
                  Communicate, integrate and <br />
                  bring people and processes <br />
                  together. We break the <br />
                  walls of the laboratory.
                </Typography>
              </div>

              <div className={classes.companyValueBox}>
                <img src="/images/team-player-icon.svg" alt="Team player icon" />

                <Typography className={classes.primaryColor} gutterBottom={true}>
                  <b>Team Player</b>
                </Typography>
                <Typography>
                  Do things with others <br />
                  in mind and be willing to <br />
                  assist the team. We create <br />
                  much better solutions <br />
                  collaboratively.
                </Typography>
              </div>

              <div className={classes.companyValueBox}>
                <img src="/images/problem-solver-icon.svg" alt="Problem solver icon" />

                <Typography className={classes.primaryColor} gutterBottom={true}>
                  <b>Problem Solver</b>
                </Typography>
                <Typography>
                  Don't be afraid to make <br />
                  things happen. Get it done. <br />
                  We solve complex problems <br />
                  and we like challenges.
                </Typography>
              </div>

              <div className={classes.companyValueBox}>
                <img src="/images/future-builder-icon.svg" alt="Future builder icon" />

                <Typography className={classes.primaryColor} gutterBottom={true}>
                  <b>Future Builder</b>
                </Typography>
                <Typography>
                  Be technical but be strategic. <br />
                  Contribute to the future of the <br />
                  business. We do everything <br />
                  with purpose.
                </Typography>
              </div>

              <div className={classes.companyValueBox}>
                <img src="/images/experimentalist-icon.svg" alt="Experimentalist icon" />

                <Typography className={classes.primaryColor} gutterBottom={true}>
                  <b>Experimentalist</b>
                </Typography>
                <Typography>
                  Nothing is ever "done". <br />
                  Try new things and assume the <br />
                  risk to fail. Things evolve as we <br />
                  move on. Have fun while doing it.
                </Typography>
              </div>
            </div>
          </LazyLoad>
        </Container>
      </Box>

      <LazyLoad>
        <Box py={6} bgcolor="common.white">
          <Container>
            <Typography
              className={classes.primaryColor}
              variant="h2"
              align="center"
              gutterBottom={true}
            >
              <b>We are trusted by</b>
            </Typography>

            <Brands />
          </Container>
        </Box>
      </LazyLoad>

      <LazyLoad>
        <Box py={6} bgcolor="grey.200">
          <Container>
            <Box mb={4}>
              <Typography className={classes.primaryColor} variant="h2" align="center">
                <b>See what people are talking about Mind The Graph!</b>
              </Typography>
            </Box>

            <Testimonials />
          </Container>
        </Box>
      </LazyLoad>

      <LazyLoad>
        <Box py={6} bgcolor="common.white">
          <Container>
            <Typography
              className={classes.primaryColor}
              variant="h2"
              align="center"
              gutterBottom={true}
            >
              <b>Our Team</b>
            </Typography>

            <div className={classes.teamAreaButtons}>
              {teamAreaButtons.map((button, index) => (
                <React.Fragment key={index}>
                  <Button
                    className={clsx(classes.teamAreaButton, {
                      [classes.teamAreaButtonActive]: teamArea === button.area,
                    })}
                    color="secondary"
                    onClick={() => setTeamArea(button.area !== teamArea ? button.area : undefined)}
                  >
                    <b>{button.label}</b>
                  </Button>

                  {index !== teamAreaButtons.length - 1 && (
                    <Divider orientation="vertical" flexItem={true} />
                  )}
                </React.Fragment>
              ))}
            </div>

            <div className={classes.teamMembers}>
              {teamMembers.map((member, index) => (
                <div key={index} className={classes.teamMemberBox}>
                  <div
                    key={index}
                    className={clsx(classes.teamMemberItem, {
                      [classes.teamMemberItemOpaque]: teamArea && teamArea !== member.area,
                    })}
                  >
                    <img src={member.avatarUrl} alt={`${member.name} avatar`} loading="lazy" />

                    <Typography gutterBottom={true}>
                      <b>{member.name}</b>
                    </Typography>

                    <Typography variant="body2">{member.role}</Typography>

                    {member.linkedinUrl && (
                      <Link href={member.linkedinUrl} target="_blank" underline="hover">
                        LinkedIn
                      </Link>
                    )}
                  </div>
                </div>
              ))}
            </div>
          </Container>
        </Box>
      </LazyLoad>

      <LazyLoad>
        <Box py={6} bgcolor="grey.200" textAlign="center">
          <Container>
            <Typography className={classes.primaryColor} variant="h2">
              <b>Join us at Mind the Graph</b>
            </Typography>

            <Button
              className={classes.button}
              variant="contained"
              color="primary"
              href="https://www.linkedin.com/company/mind-the-graph/jobs/?viewAsMember=true"
            >
              See open positions
            </Button>
          </Container>
        </Box>
      </LazyLoad>
    </>
  );
}
